import styled from "@emotion/styled";
import { Color } from "../../../../Theme";
var Backdrop = /*#__PURE__*/ styled("div", {
    target: "e1wqwqc80"
})("position:fixed;top:0;right:0;bottom:0;left:0;background-color:transparent;user-select:none;");
var TimeRange = /*#__PURE__*/ styled("div", {
    target: "e1wqwqc81"
})("display:flex;justify-content:space-between;column-gap:1rem;> *{width:100%;}");
var DatePickerWrapper = /*#__PURE__*/ styled("div", {
    target: "e1wqwqc82"
})("display:flex;position:absolute;z-index:101;border:1px solid ", Color.natural50, ";border-radius:0.75rem;flex-direction:column;width:688px;margin-top:-1px;overflow:hidden;");
var StyledSubmitButton = /*#__PURE__*/ styled("button", {
    target: "e1wqwqc83"
})("color:", Color.secondary100, ";background-color:", Color.natural0, ";border:0;padding:1rem;text-align:right;");
export { Backdrop, TimeRange, DatePickerWrapper, StyledSubmitButton };
